import UserPage from "./components/UserComponents/UserBasedPage";
import GeneralPage from "./components/CommonSettings/GeneralPage";
import NotFound from "./components/NotFound";
import Unauthorized from "./components/Unauthorized";
import Maintenance from "./components/Maintenance";
import Vue from "vue";
import VueRouter from "vue-router";
import authService from "./services/AuthService";
import env from "./properties/env.json";
Vue.use(VueRouter);

const groupName = window.location.hostname.slice(
  0,
  window.location.hostname.indexOf(".", 0)
);

const OAUTH_URL = `${window.location.protocol}//${groupName}.${
  process.env.MG_BASE_DOMAIN
}/oauth/authorize?client_id=${process.env.SSO_CLIENT_ID}&redirect_uri=${
  window.location.origin
}${window.location.pathname}&response_type=code`;

const routes = [
  {
    path: "/settings",
    component: GeneralPage,
    beforeEnter: (to, from, next) => {
      if (process.env.DEBUG_GROUP_NAME) {
        sessionStorage.setItem("hp_renkei_entry", 1);
        sessionStorage.setItem("hp_renkei_job", 1);
        sessionStorage.setItem("is_plan_dispatch_basic", 1);
        next();
        return;
      }

      if (to.query.user_id && to.query.code && to.query.group_name) {
        sessionStorage.setItem("user_id", to.query.user_id);
        checkUserRole(to.query.user_id).then(() => {
          const auth = {
            grant_type: "authorization_code",
            redirect_uri: `${window.location.origin}${
              window.location.pathname
            }`,
            user_id: to.query.user_id,
            code: to.query.code,
          };

          authService
            .getSSOToken(auth)
            .then((response) => {
              sessionStorage.setItem("token", response.data.access_token);
              sessionStorage.setItem("token_type", response.data.token_type);
              sessionStorage.setItem(
                "refresh_token",
                response.data.refresh_token
              );
              sessionStorage.setItem("expires_in", response.data.expires_in);
              getPageStatus().then(() => next());
              setInterval(refreshToken, Number(response.data.expires_in) * 900);
            })
            .catch((e) => {
              console.log(e);
              sessionStorage.clear();
              window.location = `${window.location.protocol}//${groupName}.${
                process.env.MG_BASE_DOMAIN
              }/login`;
            });
        });
      } else {
        window.location = OAUTH_URL;
      }
    },
  },
  {
    path: "/",
    component: UserPage,
  },
  {
    path: "*",
    component: NotFound,
  },
  {
    path: "/404",
    component: NotFound,
  },
  {
    path: "/401",
    component: Unauthorized,
  },
  {
    path: "/" + `${env.STATUS_MAINTENANCE}`,
    component: Maintenance,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;

function getPageStatus() {
  return authService
    .getScreenStatus()
    .then((screenStatusResponse) => {
      sessionStorage.setItem(
        "hp_renkei_entry",
        screenStatusResponse.data.is_iframe_application_entry
      );
      sessionStorage.setItem(
        "hp_renkei_job",
        screenStatusResponse.data.is_iframe_application_job
      );
      sessionStorage.setItem(
        "is_plan_dispatch_basic",
        screenStatusResponse.data.is_plan_dispatch_basic
      );
    })
    .catch((e) => {
      console.log(e);
      sessionStorage.clear();
      window.location = `${window.location.protocol}//${groupName}.${
        process.env.MG_BASE_DOMAIN
      }/login`;
    });
}

function refreshToken() {
  const auth = {
    grant_type: "refresh_token",
    refresh_token: sessionStorage.getItem("refresh_token"),
    user_id: sessionStorage.getItem("user_id"),
  };

  return authService
    .getSSOToken(auth)
    .then((response) => {
      sessionStorage.setItem("token", response.data.access_token);
      sessionStorage.setItem("token_type", response.data.token_type);
      sessionStorage.setItem("refresh_token", response.data.refresh_token);
      sessionStorage.setItem("expires_in", response.data.expires_in);
    })
    .catch((e) => {
      console.log(e);
      sessionStorage.clear();
      window.location = OAUTH_URL;
    });
}

function checkUserRole(userId) {
  if (Number(userId) !== 1 && Number(userId) !== 10001) {
    return authService
      .getUserDetail(userId)
      .then((response) => {
        if (response.data.user_role_id !== 1) {
          window.location = `${window.location.protocol}//${groupName}.${
            process.env.MG_BASE_DOMAIN
          }/login`;
        }
      })
      .catch((e) => {
        console.log(e);
        window.location = `${window.location.protocol}//${groupName}.${
          process.env.MG_BASE_DOMAIN
        }/login`;
      });
  }

  return Promise.resolve();
}
